module.exports = __webpack_public_path__ + "static/media/full-banner2.7ef1d491.jpg";